var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { staticClass: "page-title-bar" }, [
      _c("img", {
        staticStyle: { "margin-right": "10px", width: "30px" },
        attrs: { src: require("@/assets/img/camera.png") }
      }),
      _vm._v(" " + _vm._s(_vm.$t("Shelf Tasks")) + " ")
    ]),
    _c(
      "div",
      { staticClass: "mt-5" },
      [
        _c(
          "v-tabs",
          {
            staticClass: "shelf-tabs",
            attrs: { "background-color": "transparent" },
            on: { change: _vm.onTabChange },
            model: {
              value: _vm.tab,
              callback: function($$v) {
                _vm.tab = $$v
              },
              expression: "tab"
            }
          },
          [
            _c("v-tab", { staticClass: "tabs", attrs: { href: "#ALL" } }, [
              _vm._v(_vm._s(_vm.$t("All")))
            ]),
            _c("v-tab", { staticClass: "tabs", attrs: { href: "#OPEN" } }, [
              _vm._v(_vm._s(_vm.$t("Open")))
            ]),
            _c("v-tab", { staticClass: "tabs", attrs: { href: "#RESOLVED" } }, [
              _vm._v(_vm._s(_vm.$t("Resolved")))
            ]),
            _c("v-tab", { staticClass: "tabs", attrs: { href: "#PENDING" } }, [
              _vm._v(_vm._s(_vm.$t("Pending")))
            ]),
            _c("v-tab", { staticClass: "tabs", attrs: { href: "#NO_ISSUE" } }, [
              _vm._v(_vm._s(_vm.$t("No Issue")))
            ])
          ],
          1
        ),
        _c("ShelfTabItem", {
          staticClass: "mt-5",
          attrs: {
            value: _vm.tab,
            "floor-items": _vm.floorItems,
            "floor-map": _vm.floorMap
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }